import React from 'react';

import Divider from '@mui/material/Divider';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import Intent from '../../../common/Intent';
import Node from '../../../common/Node';

export default (
  ({
    appId, 
    classes,
    appTitle,
    app_impls,
    setupIntents,
    openTrplFormFull,
    toggleDeleteAppModal,
  }) => {

    return (
      <React.Fragment>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 20, marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/images/app_integration_40px.svg" alt="app integration" className={classes.mr15} />
            {appId}: {appTitle}
          </div>
          <DeleteForeverIcon
            className={`${classes.pointer} ${classes.deleteIcon}`}
            onClick={() => {
              toggleDeleteAppModal(true, appTitle, appId);
            }}
          />
        </div>
        <Divider light style={{margin: '20px 0'}}/>
        <div>
          {setupIntents.map((intent, alertIndex) => {
            return (
              // check, it should sort intents for more than one imported App
              +intent.source === +appId ? (
              <div key={alertIndex}>
                <Intent
                  intent={intent}
                  openTrplFormFull={openTrplFormFull}
                />
              </div>
            ) : null)
          })}
        </div>
        <Divider light style={{margin: '20px 0'}}/>
        <div>
          {app_impls.map((impl, index) => {
            return (
              <div key={impl.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px'}}>
                <Node
                  isLink
                  size="sm"
                  isRemovable={false}
                  nodeId={impl.id}
                  node={impl.node}
                />
                <div>
                <div style={{ margin: '0 0 4px 4px', color: impl.ako_impl_valid ? '' : 'red'}}>{`ako: ${impl.ako_min_bound < 0 ? '*' : impl.ako_min_bound} / ${impl.ako_max_bound < 0 ? '*' : impl.ako_max_bound}`}</div>
                <div style={{ margin: '0 0 4px 4px', color: impl.ioi_impl_valid ? '' : 'red'}}>{`ioi: ${impl.ioi_min_bound < 0 ? '*' : impl.ioi_min_bound} / ${impl.ioi_max_bound < 0 ? '*' : impl.ioi_max_bound}`}</div>
                <div style={{ margin: '0 0 4px 4px', color: impl.isa_impl_valid ? '' : 'red'}}>{`isa: ${impl.isa_min_bound < 0 ? '*' : impl.isa_min_bound} / ${impl.isa_max_bound < 0 ? '*' : impl.isa_max_bound}`}</div>
                </div>
              </div>
            )
          }
          )}
        </div>
      </React.Fragment>
    )
  }
);
